import SuperFetch, { AbortSuperFetch } from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';

const { build, generateFilterParam } = UrlBuilder;

type SingleProtocolReq = (params: Protocol.ParamsForSingle, signal: AbortSignal) => Promise<Response>;
type GroupProtocolReq = (params: Protocol.ParamsForGroup, signal: AbortSignal) => Promise<Response>;
type StatusProtocolReq = (params: Protocol.ParamsForStatus, signal: AbortSignal) => Promise<Response>;
type GetProtocolReq = (params: Protocol.ParamsForGet, signal: AbortSignal) => Promise<Response>;

/**
 * Klasa zawierająca metody odpowiadające za zapytania o protokoły
 */
class Protocols {
  /** Zapytanie o wygenerowanie protokołu dla pojedynczego przedmiotu */
  generateSingleProtocol: SingleProtocolReq = ({ poraRoku, kodPrzedmiotu, typPrzydzialu, kodWydzialu }, signal) => {
    const url = build(`protocol/generate`, generateFilterParam({ poraRoku, kodPrzedmiotu, typPrzydzialu, kodWydzialu }));
    return AbortSuperFetch.get(url, signal);
  };

  /** Zapytanie o wygenerowanie protokołu dla kilku przedmiotów */
  generateGroupProtocols: GroupProtocolReq = ({ poraRoku, protokoly }, signal) =>
    AbortSuperFetch.post(`protocol/generate-multi`, signal, { poraRoku, protokoly });

  /** Zapytanie o gotowość wysłanych wcześniej protokołów do generacji */
  getProtocolStatus: StatusProtocolReq = ({ kodPrzedmiotu, poraRoku }, signal) =>
    AbortSuperFetch.post(`protocol/ztn-protokoly-list`, signal, { kodPrzedmiotu, poraRoku });

  /** Pobieranie pliku PDF */
  getProtocolPdf: GetProtocolReq = ({ protId }, signal) => {
    const url = build(`protocol/pdf`, generateFilterParam({ protId }));
    return SuperFetch.get(url, signal);
  };
}

export default new Protocols();
